<template>
  <div
    v-if="slides.length > 0"
    class="custom-related-products flex flex-col bg-[color:var(--color-body-bg)] py-16 lg:space-x-8 lg:py-12"
  >
    <div class="mx-auto w-full max-w-screen-xl px-5">
      <div v-if="model.title" class="mb-6 text-3xl font-bold lg:text-4xl" v-html-safe="model.title"></div>

      <VcCustomCarousel :slides="slides" navigation :options="relatedProductsCarouselOptions">
        <template #slide="{ slide }">
          <InnoCarouselProductCard :product="slide" />
        </template>
      </VcCustomCarousel>

      <div class="flex flex-col items-center justify-between md:flex-row">
        <!-- Navigation buttons-->
        <div class="vc-carousel-custom__navigation space-1 relative flex h-16 flex-auto gap-6">
          <div class="vc-carousel-custom__btn vc-carousel-custom__btn--prev relative bottom-0 right-0">
            <VcIcon class="text-secondary rotate-180 cursor-pointer" name="veld-button" :size="65" />
          </div>

          <div class="vc-carousel-custom__btn vc-carousel-custom__btn--next relative bottom-0 left-0">
            <VcIcon class="text-secondary cursor-pointer" name="veld-button" :size="65" />
          </div>
        </div>
        <VcButton
          v-if="model.buttonLink && model.buttonTitle"
          size="lg"
          class="order-2 px-6"
          v-bind="getLinkAttr(model.buttonLink)"
        >
          {{ model.buttonTitle }}
        </VcButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { InnoCarouselProductCard, useProducts } from "@/shared/catalog";
import type { VariationType } from "@/core/api/graphql/types";
import { getLinkAttr } from "@/core/utilities/common";

type ProductsSkus = {
  productSku: string;
};

type ProductSkuType = {
  skus?: ProductsSkus[];
  query: string;
  buttonTitle?: string;
  title?: string;
  buttonLink?: string;
};

interface IProps {
  relatedProducts?: VariationType[];
  model: ProductSkuType;
}

const props = defineProps<IProps>();

const { products, fetchProducts } = useProducts();

const slides = computed(() => {
  return products.value.length > 0 ? products.value : (props.relatedProducts ?? []);
});

const relatedProductsCarouselOptions: ICarouselOptions = {
  spaceBetween: 30,
  slidesPerView: 1,
  slidesPerGroup: 1,
  breakpoints: {
    // 640: /* sm */ {},
    768: /* md */ {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    1024: /* lg */ {
      slidesPerView: 3,
      spaceBetween: 30,
      allowTouchMove: false,
    },
    1280: /* xl */ {
      slidesPerView: 4,
      spaceBetween: 20,
      allowTouchMove: false,
    },
  },
};

const productSkus = computed<string[]>(() => props.model.skus?.map((item) => item.productSku) ?? []);

onMounted(async () => {
  if (productSkus.value.length) {
    await fetchProducts({ filter: `"SKU":${productSkus.value.toString() as string}` });
  }
});
</script>

<style lang="scss">
.vc-carousel {
  $self: &;

  &-custom {
    &__btn {
      @apply relative;

      &--lock {
        @apply hidden;
      }
    }
  }
  &__btn {
    &--disabled {
      @apply cursor-auto pointer-events-none opacity-30;
    }
  }
}
</style>
